export default "__VITE_ASSET__C_6d6Z6p__"